"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenAttributesView = exports.shouldShowAttributes = exports.getFilteredAttributes = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_intl_1 = require("react-intl");
const types_1 = require("@framework/types");
const getFilteredAttributes = (metadata) => Object.entries(metadata).reduce((memo, [key, value]) => {
    switch (key) {
        // MODULE:GRADE
        case types_1.TokenMetadata.LEVEL:
            Object.assign(memo, { [key]: value });
            break;
        // MODULE:RANDOM
        case types_1.TokenMetadata.RARITY:
            Object.assign(memo, { [key]: Object.values(types_1.TokenRarity)[~~value] });
            break;
        // case TokenAttributes.TEMPLATE_ID:
        //   Object.assign(memo, { [key]: ~~value });
        //   break;
        default:
            break;
    }
    return memo;
}, {});
exports.getFilteredAttributes = getFilteredAttributes;
const shouldShowAttributes = (metadata) => {
    return Object.entries((0, exports.getFilteredAttributes)(metadata)).length > 0;
};
exports.shouldShowAttributes = shouldShowAttributes;
const TokenAttributesView = props => {
    const { metadata } = props;
    const result = (0, exports.getFilteredAttributes)(metadata);
    return ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, children: Object.entries(result).map(([key, value]) => ((0, jsx_runtime_1.jsxs)(material_1.Grid, { container: true, children: [(0, jsx_runtime_1.jsx)(material_1.Grid, { size: { xs: 6 }, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: `enums.attributeName.${key}` }) }), (0, jsx_runtime_1.jsx)(material_1.Grid, { size: { xs: 6 }, children: value })] }, key))) }));
};
exports.TokenAttributesView = TokenAttributesView;
//# sourceMappingURL=metadata.js.map